import React from 'react';
import PropTypes from 'prop-types';
import { getImage } from '../../../../utils/attachmentUtils';

import '.././PropertyDetailBasicInfo.css';

export function PropertyPhoto({
  type,
  attach,
  id,
  showSlideshow,
}) {
  const { fallback, ...image } = getImage(attach.images[0] || {}, type);
  const addDefaultSrc = ev => {
    ev.target.src = fallback; // eslint-disable-line
  };

  return (
    <div>
      <button
        className={`property-images ${showSlideshow && image.sequence >= 0 ? 'property-images--slideshow' : 'property-images--none'}`}
        onClick={() => {
          return (image.sequence >= 0 && showSlideshow) ? showSlideshow(id) : false;
        }}
      >
        <img
          key={image.sequence}
          data-sequence={image.sequence}
          src={image.filename.trim()}
          width="298"
          height="223"
          alt={image.description}
          onError={addDefaultSrc}
        />
      </button>
    </div>
  );
}

PropertyPhoto.propTypes = {
  type: PropTypes.string.isRequired,
  attach: PropTypes.object,
  id: PropTypes.string,
  showSlideshow: PropTypes.func,
};

export default PropertyPhoto;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailBasicInfo/PropertyPhoto/PropertyPhoto.js